import urls from '../constants/urls';

import { API_CLEARED } from './api';

export const LOAD_CONFIG_FAILED = 'config/LOAD_CONFIG_FAILED';
export const LOAD_CONFIG_SUCCESS = 'config/LOAD_CONFIG_SUCCESS';
export const LOADING_CONFIG = 'config/LOADING_CONFIG';

const fallbackRoles = {
  administrative_staff: 'Administrative Staff',
  allied_health_professional: 'Allied Health Professional',
  consultant_doctor: 'Consultant Doctor',
  dentist: 'Dentist',
  doctor: 'Doctor (Junior/Resident/Fellow)',
  estates: 'Estates/Porter',
  gp: 'GP',
  management: 'Management',
  midwife: 'Midwife',
  nurse: 'Nurse',
  occupational_therapist: 'Occupational Therapist',
  other: 'Other',
  pharmacist: 'Pharmacist',
  physiotherapist: 'Physiotherapist',
  psychologist: 'Psychologist/Therapist',
  scientist: 'Scientist/Public Health',
  student: 'Student',
};

const fallbackGrades = {
  junior_training_grade: 'Junior training grade',
  management: 'Management',
  middle_training_grade: 'Middle training grade',
  senior: 'Senior',
  student: 'Student',
};

const initialState = {
  config: {},
  approvedDomains: [],
  availablePbrns: [],
  locales: [],
  roles: fallbackRoles,
  grades: fallbackGrades,
  // Sign ups stay closed until the API says otherwise, so a failed config load cannot reopen them.
  signupsEnabled: false,

  failedLoading: false,

  isLoading: false,

  loaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CONFIG:
      return {
        ...state,
        failedLoading: false,
        isLoading: true,
      };

    case LOAD_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        config: action.payload.data,
        availablePbrns: action.payload.data.available_pbrns,
        locales: action.payload.data.locales,
        roles: action.payload.data.roles,
        grades: action.payload.data.grades,
        approvedDomains: action.payload.data.accredited_user_account_domains,
        signupsEnabled: action.payload.data.signups_enabled === true,
      };

    case LOAD_CONFIG_FAILED:
      return {
        ...state,
        failedLoading: true,
        isLoading: false,
      };

    case API_CLEARED:
      return initialState;

    default:
      return state;
  }
};

export const loadConfig = () => dispatch => {
  return dispatch({
    types: [LOADING_CONFIG, LOAD_CONFIG_SUCCESS, LOAD_CONFIG_FAILED],
    payload: {
      request: {
        url: urls.config,
      },
    },
  });
};
